/* eslint-disable react/prop-types */
import React from 'react';

import Icon from 'shared/Icon';
import Text from 'shared/Tipografia/Text';

import { CardInfoContent, Container, IconContent } from './styles';

export interface ICardIcon {
  iconName: string;
  title: string;
  description: string;
}

const CardIcon: React.FC<ICardIcon> = ({ iconName, title, description }) => (
  <Container>
    <IconContent>
      <Icon name={iconName} />
    </IconContent>

    <CardInfoContent>
      <Text as="h3">{title}</Text>
      <Text as="p">{description}</Text>
    </CardInfoContent>
  </Container>
);

export default CardIcon;
